import _eq from 'lodash/eq.js'

export default _eq
